module.exports = __webpack_public_path__ + "media/top/helpful_info_article_01-469835d9.svg";